export const featuredCategoryTitle = "Related Categories";
